'use strict';

var shape = {
  borderRadius: 4
};
var shape$1 = shape;

module.exports = shape$1;
